(function () {
  var io;

  function getIo() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    return io;
  }

  function wire(els) {
    var observer = getIo();
    els.forEach(function (el) {
      if (!observer) { el.classList.add('is-in'); return; }
      observer.observe(el);
    });
  }

  function init() {
    wire(document.querySelectorAll('[data-reveal]:not(.is-in)'));
  }

  function watch() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var found = [];
          if (node.matches && node.matches('[data-reveal]:not(.is-in)')) found.push(node);
          if (node.querySelectorAll) {
            found = found.concat(Array.prototype.slice.call(node.querySelectorAll('[data-reveal]:not(.is-in)')));
          }
          if (found.length) wire(found);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('DOMContentLoaded', watch);
})();
